import {
  DeviceGroupModel,
  MoveDevicesToGroupReqModel
} from '@models/digital-signage/device-groups.model.ts';
import { DeviceGroupOption } from './device-groups.model.ts';
import { TableSelectionColumnParams } from '@models/table.model.ts';

export enum DeviceLocationEnum {
  Signage = 'signage'
}

export interface DevicesRowDataProps {
  id?: number;
  _id?: string;
  ip: string;
  name: string;
  model?: string;
  deviceId?: string;
  remoteId: string;
  type: string;
  os: string;
  isActive: boolean;
  code: number | null;
  warehouseId: number | null;
  roomId: number | null;
  deviceGroup?: DeviceGroupModel | null;
}

export interface AsignScreenFormProps {
  handleClose: () => void;
  tableStore: any;
  screensList?: any;
  selectedItem?: any;
}

export interface DeviceAsignScreenModel {
  id: string;
  screenId: string | number | null;
}

export interface DevicesActionsProps {
  row: DevicesRowDataProps;
  handleEdit?: (row: DevicesRowDataProps) => void;
  reloadDevice: (row: DevicesRowDataProps) => void;
  handleDelete: (row: DevicesRowDataProps) => void;
  handleAddScreen: (row: DevicesRowDataProps) => void;
  handleMoveToGroup: (row: DevicesRowDataProps) => void;
}

export interface DeviceColumnsParams
  extends
    Omit<DevicesActionsProps, 'row' | 'handleEdit'>,
    TableSelectionColumnParams<DevicesRowDataProps> {
  deviceGroupsData: DeviceGroupOption[];
}

export interface MoveToGroupFormValues {
  deviceGroup: DeviceGroupOption | null;
}

export interface DevicesExtraButtonsProps {
  selectedRows: string[];
  onMoveToGroup: () => void;
}

export interface GroupedDevicesModel {
  groupId: string;
  groupName: string;
  devices: DevicesRowDataProps[];
}

export interface DevicesChipsAutocompleteProps {
  value: DevicesRowDataProps[];
  options: DevicesRowDataProps[];
  onChange: (devices: DevicesRowDataProps[]) => void;
  placeholder?: string;
  limitTags?: number;
  disabled?: boolean;
}

export interface MoveToGroupAlertProps {
  sourceDevices: DevicesRowDataProps[];
  selectedDevices: DevicesRowDataProps[];
  onChange: (devices: DevicesRowDataProps[]) => void;
}

export interface MoveToGroupDialogFormProps {
  sourceDevices: DevicesRowDataProps[];
  selectedDevices: DevicesRowDataProps[];
  deviceGroupsData: DeviceGroupOption[];
  onDevicesChange: (devices: DevicesRowDataProps[]) => void;
  onSave: (body: MoveDevicesToGroupReqModel) => void;
}
